module.exports = __webpack_public_path__ + "static/media/tiger.af5e2843.svg";